
export default function Eye() {
  return (
    <svg
    width="20"
    height="18"
    viewBox="0 0 30 20"
    fill="#fff"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.9138 10.4061C29.9138 10.4061 29.6346 11.0344 29.065 11.9391C29.065 11.9391 27.9427 13.7215 26.4571 15.2071C26.4571 15.2071 21.6642 20 15 20C15 20 8.33579 20 3.54289 15.2071C3.54289 15.2071 2.0573 13.7215 0.935017 11.9391C0.935017 11.9391 0.36542 11.0344 0.0861884 10.4061C-0.0287295 10.1476 -0.0287295 9.85243 0.0861885 9.59386C0.0861885 9.59386 0.365419 8.96559 0.935017 8.06094C0.935017 8.06094 2.0573 6.27848 3.54289 4.79289C3.54289 4.79289 8.33579 0 15 0C15 0 21.6642 0 26.4571 4.79289C26.4571 4.79289 27.9427 6.27847 29.065 8.06094C29.065 8.06094 29.6346 8.96558 29.9138 9.59386C30.0287 9.85243 30.0287 10.1476 29.9138 10.4061ZM27.3725 10.8734C27.3725 10.8734 27.6833 10.3798 27.8859 10C27.8859 10 27.6833 9.62016 27.3725 9.12656C27.3725 9.12656 26.3698 7.53401 25.0429 6.20711C25.0429 6.20711 20.8358 2 15 2C15 2 9.16422 2 4.95711 6.20711C4.95711 6.20711 3.6302 7.53401 2.62748 9.12656C2.62748 9.12656 2.31671 9.62015 2.11411 10C2.11411 10 2.31671 10.3799 2.62748 10.8734C2.62748 10.8734 3.6302 12.466 4.95711 13.7929C4.95711 13.7929 9.16422 18 15 18C15 18 20.8358 18 25.0429 13.7929C25.0429 13.7929 26.3698 12.466 27.3725 10.8734Z"
      fill="#1C1C1C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 4C15 4 17.4853 4 19.2426 5.75736C19.2426 5.75736 21 7.51472 21 10C21 10 21 12.4853 19.2426 14.2426C19.2426 14.2426 17.4853 16 15 16C15 16 12.5147 16 10.7574 14.2426C10.7574 14.2426 9 12.4853 9 10C9 10 9 7.51472 10.7574 5.75736C10.7574 5.75736 12.5147 4 15 4ZM15 6C15 6 13.3431 6 12.1716 7.17157C12.1716 7.17157 11 8.34315 11 10C11 10 11 11.6569 12.1716 12.8284C12.1716 12.8284 13.3431 14 15 14C15 14 16.6569 14 17.8284 12.8284C17.8284 12.8284 19 11.6569 19 10C19 10 19 8.34315 17.8284 7.17157C17.8284 7.17157 16.6569 6 15 6Z"
      fill="#1C1C1C"
    />
  </svg>
  );
}
